/**
 * Vids
 * Fluid-width video helper
 */

import { closest, wrap } from '../lib';

export default function (scope) {
  scope = scope || document;
  const videos = scope.querySelectorAll(
    'iframe[src*="player.vimeo.com"], iframe[src*="youtube.com"], iframe[src*="youtube-nocookie.com"], iframe[src*="kickstarter.com"][src*="video.html"], object, embed',
  );
  videos.forEach(video => {
    if (closest(video, '.video') === false) {
      wrap(video, 'video');
    }
  });
}



// WEBPACK FOOTER //
// ./components/_vids.js